if (typeof globalThis.crypto === 'undefined') {
    globalThis.crypto = window.crypto as Crypto;
  }
  
// Core
export { TaarWebRTC } from './core/TaarWebRTC';

// Logger
export { 
  UnifiedLogger,
  initializeLogger,
  getLogger,
  getLogs,
  sendLogsToBackend,
  getTimerLogs,
  getTransactionLogs,
  type LoggingConfig,
  type LogEntry,
  type LogContext,
  type BatchLogEntry,
  TaarWebRTCEvents
} from './core/logger';

// Types
export type {
  AgentConfig,
  SIPCredentials,
  CallMeta,
  VolumeInfo,
  TaarWebRTCConfig,
  TaarWebRTCState,
  TaarWebRTCMethods,
} from './types';
